import { IProgramsListFilters } from '~/services/api/programs/types';

const initialValues: IProgramsListFilters = {
  name: '',
};

export default initialValues;
